// NATIVE

// INSTALLED

// CUSTOM
import { storageGetAdminPermissions } from '../commons/utils';

export const usePermissions = () => {
  const initCheckPermissons = async () => {
    const permissions: any = await storageGetAdminPermissions();
    return permissions;
  };

  return [initCheckPermissons];
};
